jQuery(document).ready(function () {

    jQuery("select").selectric({
        openOnFocus: false,
        disableOnMobile: false,
        nativeOnMobile: false
    });

    jQuery('.testimonial_slider').slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        infinite: true,
        arrows: false,
        dots: false,
        speed: 900,
        autoplay: true,
        autoplaySpeed: 5000,
    });

    jQuery('.history_slider_for').slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
        fade: true,
        dots: false,
        infinite: true,
        autoplay: true,
        autoplaySpeed: 5000,
        asNavFor: '.history_slider_nav'
    });
    jQuery('.history_slider_nav').slick({
        slidesToShow: 7,
        slidesToScroll: 1,
        asNavFor: '.history_slider_for',
        dots: false,
        arrows: false,
        focusOnSelect: true,
        infinite: true,
        responsive: [{
            breakpoint: 1360,
            settings: {
                slidesToShow: 6,
                slidesToScroll: 1,
            }
        },
        {
            breakpoint: 1200,
            settings: {
                slidesToShow: 5,
                slidesToScroll: 1,
            }
        },
        {
            breakpoint: 992,
            settings: {
                slidesToShow: 4,
                slidesToScroll: 1,
            }
        },

        {
            breakpoint: 575,
            settings: {
                slidesToShow: 3,
                slidesToScroll: 1,
            }
        },
        ]
    });

    jQuery(".section_left_image_right_detail_file_download_and_video_popup .video_link").click(function () {
        setTimeout(function () {
            jQuery('.lity').addClass('co_operative_popup_open');
            jQuery('body').addClass('co_operative_popup_active');
        });
    });

})
